import { z } from "zod";

export const SchemaNewPassword = z
  .object({
    password: z.string().min(6, "A senha deve ter ao menos 6 caracteres"),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "As senhas não coincidem.",
    path: ["confirmPassword"],
  });

export type SchemaNewPasswordType = z.infer<typeof SchemaNewPassword>;
